module.exports = __webpack_public_path__ + "static/media/ct.3e555728.jpg";